import { render } from "./KpsOrdersView.vue?vue&type=template&id=35cc1321&scoped=true"
import script from "./KpsOrdersView.vue?vue&type=script&lang=js"
export * from "./KpsOrdersView.vue?vue&type=script&lang=js"

import "./KpsOrdersView.vue?vue&type=style&index=0&id=35cc1321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cc1321"]])

export default __exports__